import React, { useState, useEffect } from 'react';

const AdminLiveUsers = () => {
  const [data, setData] = useState({ users: [], online: 0, away: 0, total: 0 });
  const [loading, setLoading] = useState(true);

  const fetchPresence = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const res = await fetch('/api/presence/online', {
        headers: { 'Authorization': 'Bearer ' + token }
      });
      const d = await res.json();
      if (d.users) setData(d);
    } catch (e) { console.error('Presence fetch error:', e); }
    setLoading(false);
  };

  useEffect(() => {
    fetchPresence();
    const interval = setInterval(fetchPresence, 30000);
    return () => clearInterval(interval);
  }, []);

  const statusDot = (status) => ({
    width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0,
    background: status === 'online' ? '#10b981' : status === 'away' ? '#eab308' : '#ef4444',
    boxShadow: '0 0 6px ' + (status === 'online' ? 'rgba(16,185,129,0.5)' : status === 'away' ? 'rgba(234,179,8,0.5)' : 'rgba(239,68,68,0.5)')
  });

  const planBadge = (plan) => ({
    padding: '2px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px',
    background: plan === 'business' ? 'rgba(16,185,129,0.15)' : plan === 'pro' ? 'rgba(139,92,246,0.15)' : 'rgba(100,116,139,0.15)',
    color: plan === 'business' ? '#10b981' : plan === 'pro' ? '#a78bfa' : '#94a3b8'
  });

  const timeAgo = (dateStr) => {
    const diff = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return mins + 'm ago';
    const hrs = Math.floor(mins / 60);
    return hrs + 'h ago';
  };

  if (loading) return <div style={{padding:'16px',textAlign:'center',color:'#64748b',fontSize:'13px'}}>Loading...</div>;

  const sorted = [...data.users].sort((a, b) => {
    const order = { online: 0, away: 1, offline: 2 };
    return (order[a.status] || 2) - (order[b.status] || 2);
  });

  return (
    <div>
      {/* Summary Badges */}
      <div style={{display:'flex',gap:'8px',marginBottom:'14px',flexWrap:'wrap'}}>
        <div style={{padding:'6px 14px',borderRadius:'20px',background:'rgba(16,185,129,0.1)',border:'1px solid rgba(16,185,129,0.2)',display:'flex',alignItems:'center',gap:'6px'}}>
          <div style={statusDot('online')}></div>
          <span style={{color:'#10b981',fontSize:'13px',fontWeight:'700'}}>{data.online} Online</span>
        </div>
        <div style={{padding:'6px 14px',borderRadius:'20px',background:'rgba(234,179,8,0.1)',border:'1px solid rgba(234,179,8,0.2)',display:'flex',alignItems:'center',gap:'6px'}}>
          <div style={statusDot('away')}></div>
          <span style={{color:'#eab308',fontSize:'13px',fontWeight:'700'}}>{data.away} Away</span>
        </div>
        <div style={{padding:'6px 14px',borderRadius:'20px',background:'rgba(100,116,139,0.1)',border:'1px solid rgba(100,116,139,0.2)',display:'flex',alignItems:'center',gap:'6px'}}>
          <div style={statusDot('offline')}></div>
          <span style={{color:'#94a3b8',fontSize:'13px',fontWeight:'700'}}>{Math.max(0, data.total - data.online - data.away)} Offline</span>
        </div>
      </div>

      {/* User List */}
      {sorted.length === 0 ? (
        <div style={{textAlign:'center',padding:'20px',color:'#475569',fontSize:'13px'}}>No recent sessions</div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:'8px',maxHeight:'300px',overflowY:'auto'}}>
          {sorted.map((u, i) => (
            <div key={i} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',background:'rgba(255,255,255,0.03)',borderRadius:'10px',border:'1px solid rgba(255,255,255,0.06)',gap:'8px',flexWrap:'wrap'}}>
              <div style={{display:'flex',alignItems:'center',gap:'10px',minWidth:0,flex:1}}>
                <div style={statusDot(u.status)}></div>
                <div style={{minWidth:0}}>
                  <div style={{color:'#fff',fontSize:'13px',fontWeight:'600',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{u.name}</div>
                  <div style={{color:'#475569',fontSize:'11px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{u.email}</div>
                </div>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:'8px',flexShrink:0}}>
                <span style={planBadge(u.plan)}>{u.plan}</span>
                <span style={{color:'#475569',fontSize:'11px',fontWeight:'500'}}>{timeAgo(u.lastSeen)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminLiveUsers;
